




























import Vue from "vue";

import { onMounted, Ref, ref } from "@vue/composition-api";
import { SharedState } from "@/common/state";
import { UseDevice } from "@/common/state/device.state";
import { CMS } from "@/common/state/cms/cms.api";
import { UseLoading } from "@/common/composition/loading";
import { PartnerIdStorage } from "@/storage";
import UnSupportedUserError from "./UnSupportedUserError.vue";
import LoginBox from "./LoginBox.vue";
export default Vue.extend({
  components: {
    UnSupportedUserError,

    LoginBox,
  },
  setup(_, { root: { $router } }) {
    const logo_url: Ref<null | string> = ref(null);
    const partner_id: Ref<null | string> = ref(null);
    const [is_loading, set_is_loading] = UseLoading(false).as_arr();
    const unsupported_user = ref("");
    const { isMobile } = UseDevice();

    const set_has_light_theme_just_for_login = () => {
      SharedState.change_theme_locally("light");
    };

    onMounted(async () => {
      set_is_loading(true);
      if (PartnerIdStorage.exist()) {
        const res = await CMS.get_partner_data(
          PartnerIdStorage.get() as string
        );
        if (res.success) {
          const { icon, id } = res.value[0] || { icon: "cognni", id: "cognni" };
          partner_id.value = id;
          logo_url.value = icon;
        }
      } else {
        partner_id.value = "cognni";
        logo_url.value = "cognni";
      }
      set_is_loading(false);
      unsupported_user.value = SharedState.rejected_user_email.value;
      set_has_light_theme_just_for_login();
      SharedState.onReady(() => {
        if (SharedState.isUserLogged.value) {
          $router.replace({ name: "Overview" });
        }
      });
    });

    return {
      is_loading,
      logo_url,
      partner_id,
      isMobile,
      unsupported_user,
    };
  },
});
